import { IAuditEvent, IFlow } from '@diana/core';
import { DataChangeDetails } from '../../../../components/Tabs/Activities/DataChangeDetails';

interface IDataChangeDetails {
  keyword: string | null;
  workId?: string;
  flow?: IFlow | null;
  audit: IAuditEvent;
}

export const WorkAuditDataChangeDetails = (props: IDataChangeDetails) => {
  // const { flow } = props;
  //
  // if (flow?.featureFlags?.isActivityLogV2) {
  //   return <WorkDataChangeDetailsV2 {...props} />;
  // }

  return <WorkDataChangeDetailsV2 {...props} />;
};

// export const WorkDataChangeDetailsV1 = (props: IDataChangeDetails) => {
//   const { workId, audit, keyword } = props;
//
//   const query = workAuditQuery.getDataChange({
//     workId: workId ?? '',
//     eventName: audit.activity.eventName ?? 'edited',
//     userId: audit.user.userId,
//     sectionId: audit.activity.sectionId ?? '',
//     userDisplayName: audit.user.displayName ?? '',
//   });
//
//   const { data, isLoading, refetch } = useQuery({ queryKey: query.key, queryFn: query.fn });
//   const debouncedRefetch = useDebouncedCallback(refetch, 500);
//
//   useEvents((ctx) => {
//     WhenWorkPartiallyChanged.attach(ctx, (params) => {
//       if (params.workItemId === workId) {
//         debouncedRefetch();
//       }
//     });
//   }, []);
//
//   return <DataChangeDetails keyword={keyword} data={data} isLoading={isLoading} />;
// };

export const WorkDataChangeDetailsV2 = (props: IDataChangeDetails) => {
  const { audit, keyword } = props;

  return <DataChangeDetails keyword={keyword} data={audit} isLoading={false} />;
};
